import { Radio } from '@mantine/core'
import classes from './Radio.module.css'

export const RadioThemeKobo = Radio.extend({
  classNames: classes,
})
